<template>
  <div class="home-page">
    <div class="home-overlay">
      <h1>大理市定点医药机构分布图</h1>

      <div class="home-actions">
        <router-link
          class="home-card"
          :to="{ name: 'map', query: { source: 'institutions' } }"
        >
          <span class="home-card__button">
            <img class="home-card__icon-image" :src="institutionIcon" alt="">
            <span>定点医疗机构</span>
          </span>
        </router-link>

        <router-link
          class="home-card"
          :to="{ name: 'map', query: { source: 'pharmacies' } }"
        >
          <span class="home-card__button">
            <img class="home-card__icon-image" :src="pharmacyIcon" alt="">
            <span>定点零售药店</span>
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import institutionIcon from '../assets/jigou.svg'
import pharmacyIcon from '../assets/yaodian.svg'

export default {
  name: 'HomeView',
  data() {
    return {
      institutionIcon,
      pharmacyIcon
    }
  }
}
</script>

<style>
.home-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(24px, 2vw, 56px);
  box-sizing: border-box;
  background: url('../assets/bg.png') center top / cover no-repeat;
}

.home-overlay {
  width: min(1760px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(clamp(-8px, 1.6vh, 36px));
  text-align: center;
}

.home-overlay h1 {
  margin: 0 0 clamp(136px, 12vh, 260px);
  color: #0b4db8;
  font-size: clamp(58px, 5.2vw, 138px);
  line-height: 1.18;
  text-shadow: 0 8px 16px rgba(11, 77, 184, 0.22);
}

.home-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: clamp(32px, 3.2vw, 84px);
  width: min(1260px, 100%);
  margin: 0 auto;
  justify-content: center;
}

.home-card {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: clamp(140px, 8.8vw, 196px);
  padding: clamp(20px, 1.4vw, 32px);
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 18px 40px rgba(16, 38, 63, 0.12);
  color: #fff;
  text-decoration: none;
  backdrop-filter: blur(12px);
}

.home-card__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: clamp(14px, 0.9vw, 24px);
  width: 100%;
  max-width: 520px;
  height: clamp(96px, 5.6vw, 140px);
  padding: 0 clamp(28px, 1.6vw, 40px);
  border-radius: 16px;
  background: linear-gradient(135deg, #2f81ff, #5aa0ff);
  box-shadow: 0 12px 24px rgba(47, 129, 255, 0.22);
}

.home-card__button span {
  font-size: clamp(28px, 2vw, 48px);
  font-weight: 700;
}

.home-card__icon-image {
  width: clamp(52px, 3vw, 74px);
  height: clamp(52px, 3vw, 74px);
  flex-shrink: 0;
}

@media (min-width: 2560px) {
  .home-overlay {
    width: min(1760px, 100%);
    transform: translateY(clamp(0px, 2.4vh, 56px));
  }

  .home-overlay h1 {
    margin-bottom: clamp(164px, 12vh, 280px);
  }

  .home-actions {
    width: min(1500px, 100%);
    gap: clamp(56px, 3.2vw, 120px);
  }

  .home-card {
    padding: 28px 32px;
  }

  .home-card__button {
    max-width: 560px;
  }
}

@media (min-width: 3000px) and (min-height: 1600px) {
  .home-page {
    align-items: center;
    padding: 64px 72px 88px;
  }

  .home-overlay {
    width: min(2400px, 100%);
    transform: translateY(clamp(12px, 3vh, 72px));
  }

  .home-overlay h1 {
    margin-bottom: clamp(220px, 18vh, 420px);
    font-size: clamp(160px, 8.1vw, 228px);
    line-height: 1;
    letter-spacing: 0.01em;
    white-space: nowrap;
    text-shadow: 0 14px 28px rgba(11, 77, 184, 0.2);
  }

  .home-actions {
    width: min(1700px, 100%);
    gap: clamp(86px, 4.8vw, 180px);
  }

  .home-card {
    min-height: 240px;
    padding: 34px 38px;
    border-radius: 30px;
    box-shadow: 0 24px 54px rgba(16, 38, 63, 0.14);
  }

  .home-card__button {
    max-width: none;
    height: 138px;
    border-radius: 22px;
    gap: 26px;
    padding: 0 44px;
  }

  .home-card__button span {
    font-size: clamp(44px, 2vw, 62px);
  }

  .home-card__icon-image {
    width: 84px;
    height: 84px;
  }
}

@media (max-width: 960px) {
  .home-page {
    padding: 24px;
    background-position: 36% center;
  }

  .home-overlay {
    width: 100%;
    transform: none;
  }

  .home-overlay h1 {
    margin-bottom: 36px;
  }

  .home-actions {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .home-card__button {
    max-width: none;
  }

  .home-card__button span {
    font-size: 30px;
  }
}
</style>
